export default "__VITE_ASSET__CEDvAd48__"